import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { AlertService } from '../../providers/alert-service';
import { EspeciesProcessuaisService } from '../../providers/especies-processuais-service';

@Component({
  selector: 'page-especies-processuais',
  templateUrl: 'especies-processuais.html',
  providers: [
    EspeciesProcessuaisService
  ]
})
export class EspeciesProcessuaisPage {

  listaDados: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public especiesProcessuaisService: EspeciesProcessuaisService,
    public modalCtrl: ModalController,
    public alertService: AlertService) {
    this.carregarPagina();
  }

  carregarPagina() {
    this.especiesProcessuaisService.listarEspeciesProcessuais().subscribe(data => {
      this.listaDados = data;
    }, error => console.log("erro: " + error));
  }

  salvarDados() {
    this.especiesProcessuaisService.salvarEspeciesProcessuais(this.listaDados).subscribe(data => {
      this.alertService.mostraAlerta("", "Espécies salvas com sucesso!");
      this.carregarPagina();
    }, error => {
      this.alertService.mostraAlerta("", "Hove um erro ao salvar as espécies:" + error);
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/especies-processuais/especies-processuais.ts